import { render, staticRenderFns } from "./TopStudentsWidget.vue?vue&type=template&id=59a5d058&scoped=true&"
import script from "./TopStudentsWidget.vue?vue&type=script&lang=js&"
export * from "./TopStudentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./TopStudentsWidget.vue?vue&type=style&index=0&id=59a5d058&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a5d058",
  null
  
)

export default component.exports